import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { currentClaims, Role } from "../lib/auth";

/** Redirects to /login (preserving where we tried to go) if the
 * user has no valid JWT. Renders `children` otherwise. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const claims = currentClaims();
  const location = useLocation();
  if (!claims) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <>{children}</>;
}

/** Client-side pre-check: hide UI branches the caller's role can't
 * reach. The backend is still authoritative on every API call. */
export function RequireRole({
  roles, children,
}: {
  roles: Role[];
  children: ReactNode;
}) {
  const claims = currentClaims();
  const location = useLocation();
  if (!claims) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (!roles.includes(claims.role)) {
    return (
      <div className="p-8 text-center">
        <h2 className="text-2xl font-semibold text-red-700">Not authorized</h2>
        <p className="mt-2 text-gray-600">
          You don't have access to this page.
        </p>
      </div>
    );
  }
  return <>{children}</>;
}
